var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"disabled":_vm.disabled,"content":_vm.content,"popper-class":"fixed-tooltip"}},[_c('div',{ref:"wrapRef",staticClass:"truncate inline-block box-border",class:_vm.wrapClass,style:({maxWidth:_vm.width})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }